// Date-range presets for the Reports page. Each preset computes ISO YYYY-MM-DD
// start/end dates (local time) that are passed to the backend data endpoints.

function fmt(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
}

export const DATE_PRESETS = [
  {
    id: "last_7",
    label: "Last 7 days",
    compute: () => ({ startDate: fmt(daysAgo(7)), endDate: fmt(daysAgo(1)) }),
  },
  {
    id: "last_30",
    label: "Last 30 days",
    compute: () => ({ startDate: fmt(daysAgo(30)), endDate: fmt(daysAgo(1)) }),
  },
  {
    id: "this_month",
    label: "This month",
    compute: () => {
      const now = new Date();
      return { startDate: fmt(new Date(now.getFullYear(), now.getMonth(), 1)), endDate: fmt(now) };
    },
  },
  {
    id: "last_month",
    label: "Last month",
    compute: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return { startDate: fmt(start), endDate: fmt(end) };
    },
  },
];

export const DEFAULT_PRESET_ID = "last_30";

export function getPreset(id) {
  return DATE_PRESETS.find((p) => p.id === id) || DATE_PRESETS[1];
}

export function rangeLabel(preset, startDate, endDate) {
  return `${preset.label} (${startDate} \u2013 ${endDate})`;
}
